module.exports = __webpack_public_path__ + "static/media/arm-min.27ee0f24.png";